import { HttpEventType } from "@angular/common/http";
import { AfterContentChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { SafeUrl } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NzModalService, NzNotificationService } from "ng-zorro-antd";
import { ExportEformRequestModel, RequestParams } from "src/app/models/forms-get.models";
import { FormsService } from "src/app/services/forms.service";
import { FooterComponent } from "../../footer/footer.component";
import { HeaderComponent } from "../../header/header.component";

@Component({
    selector: 'app-component-eform-completed',
    templateUrl: './eform-completed.component.html',
    styleUrls: ['./eform-completed.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class EformCompletedComponent implements OnInit, AfterContentChecked, AfterViewInit {
    @ViewChild(HeaderComponent) header;
    @ViewChild(FooterComponent) footer;
    public enterprise: string = "";
    public account_number: string = "";
    requestMod: RequestParams;
    imgQrCode: string;
    formCode: string;
    customerCode: string;
    qrUrl: SafeUrl = '';
    taxcode: string;
    version: number;
    isSendingData: boolean = true;
    eformRequestMod: ExportEformRequestModel;
    constructor(
        private formBuilder: FormBuilder,
        private nzModal: NzModalService,
        private nzNotification: NzNotificationService,
        private cdref: ChangeDetectorRef,
        private router: Router,
        private formService: FormsService
    ) { }
    ngAfterViewInit(): void {
        //Active class DN header
        let CNEle = this.header.navEl.nativeElement.children[0].querySelector('a');
        if(CNEle.classList.contains('active')){
            CNEle.classList.remove('active');
        }

        let DNEle = this.header.navEl.nativeElement.children[1].querySelector('a');
        if(!DNEle.classList.contains('active')){
            DNEle.classList.add('active');
        }
        //ACtive class DN footer
        CNEle = this.footer.navEl.nativeElement.children[0].querySelector('a');
        if(CNEle.classList.contains('active')){
            CNEle.classList.remove('active');
        }

        DNEle = this.footer.navEl.nativeElement.children[1].querySelector('a');
        if(!DNEle.classList.contains('active')){
            DNEle.classList.add('active');
        }
    }

    ngOnInit() {
        this.taxcode = localStorage.getItem('TAXCODE');
        this.formCode = localStorage.getItem('FORM_CODE');
        this.customerCode = localStorage.getItem('CUSTOMER_CODE');
        this.version = parseInt(localStorage.getItem('FORM_VERSION'));
        if (this.taxcode) {
            this.getFormByGuid(this.formCode, this.taxcode);
        }
        else {
            this.router.navigate(['/khdn-bieumau']);
        }

    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    getFormByGuid(formCode: string, taxcode: string) {
        this.requestMod = { FormCode: formCode, TaxCode: taxcode }
        this.formService.getQRCodeByTaxCode(this.requestMod).subscribe(res => {
            if (res.result.isSuccess && res.result.value.result) {
                //let result = res.result.value.result;
                this.imgQrCode = 'http://beta-service.sacombank.com/sq/khdn-bieumau?code=' + this.formCode + '&taxcode=' + this.taxcode;
            }
            else {
                this.nzNotification.error("Error", "Có lỗi xảy ra khi xử lý dữ liệu");
            }
        }, error => {
            this.nzNotification.error("Error", error);
        })
        this.enterprise = localStorage.getItem('VALUE_' + formCode + '_' + taxcode + '_SYS_CustomerName');
        this.account_number = taxcode;
    }

    downloadQRCode() {
        var canvas = document.getElementsByTagName("canvas")[0];
        var img = canvas.toDataURL("image/png");
        var aTag = document.createElement('a');
        aTag.href = img;
        aTag.download = "image_qr.png";
        document.body.appendChild(aTag);
        aTag.click();
        document.body.removeChild(aTag);
    }

    printForm() {
        this.isSendingData = false;
        this.eformRequestMod = {
            FormCode: this.formCode,
            CustomerIdentity: this.taxcode,
            CustomerCode: (this.customerCode) ? this.customerCode : "",
            IsDualLanguage: false,
            FormVersion: this.version
        }
        this.formService.exportEform(this.eformRequestMod)
            .subscribe((res) => {
                this.isSendingData = true;
                switch (res.type) {
                    case HttpEventType.DownloadProgress:
                        break;
                    case HttpEventType.Response:
                        const downloadedFile = new Blob([res.body], {
                            type: res.body.type,
                        });
                        const a = document.createElement("a");
                        a.setAttribute("style", "display:none;");
                        document.body.appendChild(a);
                        a.download = this.formCode + '_' + this.taxcode;
                        a.href = URL.createObjectURL(downloadedFile);
                        a.target = "_blank";
                        a.click();
                        document.body.removeChild(a);
                        break;
                }
            }, (err) => {
                this.isSendingData = true;
            });
    }
}